/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';


@Injectable()
export class ApproveQService {

  constructor(private http: HttpClient) { }

  getByEmailDetail(emailDetailId: string) {
    return this.http
      .get(
        `/api/v1/approve_q/${emailDetailId}`
      );
  }

  /**
   * Technically this impacts batch_q AND bot_q - put here for convenince so we don't need another service
   * @param batchQId
   */
  stopPending(respondQId: string, trackQId: string) {
    return this.http
      .post(
        `/api/v1/approve_q/movetodraft`,
        JSON.stringify({ respondQId: respondQId, trackQId: trackQId })
      );
  }

  /**
   * Technically this impacts batch_q AND bot_q - put here for convenince so we don't need another service
   * @param approveQId
   */
  approveDraft(respondQId: string, trackQId: string, content: string, cc:any[]) {
    return this.http
      .post(
        `/api/v1/approve_q/approvedraft`,
        JSON.stringify({ respondQId: respondQId, trackQId: trackQId, content: content,cc:cc })
      );
  }

  deleteDraft(emailDetailId: string, respondQId: string, trackQId, updateTask: boolean) {
    return this.http
      .post(
        `/api/v1/approve_q/deletedraft`,
        JSON.stringify({ emailDetailId: emailDetailId, respondQId: respondQId, trackQId: trackQId, updateTask: updateTask })
      );
  }

  changeCategory(emailDetailId: string, automateJobId: string, categoryId: string) {
    return this.http
      .post(
        `/api/v1/approve_q/changecategory`,
        JSON.stringify({ emailDetailId: emailDetailId, automateJobId: automateJobId, categoryId: categoryId })
      )
      .map((response: any) => {
        return response;
      });
  }

  /**
   * Change action from draft to customer
   * @param id
   */
  customerQueue(id) {
    return this.http
    .post(
      `/api/v1/approve_q/customer`,
      JSON.stringify({_id : id})
    );
  }

  /**
   * Change action to draft for all email details linked to account
   * @param accountId
   */
  toggleReviewQueueOff(accountId) {
    return this.http
    .post(
      `/api/v1/approve_q/toggleoff`,
      JSON.stringify({account_id : accountId})
    );
  }

}



// WEBPACK FOOTER //
// ./client/app/services/approve-q.service.ts